import Page from '../../../shared/components/Page/Page';
import {Button, Card, Col, Flex, Form, message, Modal, Popconfirm, QRCode, Row, Space, Table, Tag} from "antd";
import {useContext, useEffect, useState} from "react";
import LoadingContext from "../../../app/contexts/LoadingContext";
import {formatDateTime, numberFormat} from "../../../shared/utils/helpers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan} from "@fortawesome/free-solid-svg-icons";
import TextCopy from "../../../shared/components/TextCopy";
import { adminGetWithdrawals as getWithdrawals } from "../api";
import {CheckOutlined, QrcodeOutlined} from "@ant-design/icons";
import { getImageQrCode } from "../api";
import { updateWithdraw } from "../api";
import dayjs from "dayjs";
import { searchPartner } from "../../partner/api";
import {DatePicker, Select} from "antd";
const { RangePicker } = DatePicker;
function Withdraw() {
    const {setLoading} = useContext(LoadingContext);
    const [, contextHolder] = message.useMessage();
    const [dataSource,setDataSource] = useState([]);
    const [tableLoading,setTableLoading] = useState(false);
    const [qrCode,setQrcode] = useState('');
    const [openModal,setOpenModal] = useState(false);
    const [optionQuery,setOptionQuery] = useState([]);
    const [query,setQuery] = useState('');
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        search: {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        }
    });
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            align: 'center',
            sorter: true
        },
        {
            title: 'Ngân hàng',
            dataIndex: 'bankName'
        },
        {
            title: 'Đối tác',
            dataIndex: 'username',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Số tài khoản',
            dataIndex: 'accountNumber',
            align: 'center',
            render: (value) => {
                return (
                    <TextCopy value={value}/>
                )
            }
        },
        {
            title: 'Tên tài khoản',
            dataIndex: 'accountName',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Số tiền',
            dataIndex: 'amount',
            sorter: true,
            align: 'center',
            render: (value) => {
                return numberFormat(value);
            }
        },
        {
            title: 'Ghi chú',
            dataIndex: 'note',
            width: '200px',
            align: 'center'
        },
        {
            title: 'Trạng thái',
            dataIndex: 'state',
            align: 'center',
            filters: [
                {
                    text: 'Chờ duyệt',
                    value: 'pending'
                },
                {
                    text: 'Đã duyệt',
                    value: 'processed'
                },
                {
                    text: 'Bị từ chối',
                    value: 'refused'
                }
            ],
            render: (value) => {
                if (value === 'pending') {
                    return <Tag color={'yellow'}>Chờ duyệt</Tag>
                }
                else if (value === "processed") {
                    return <Tag color={'green'}>Đã duyệt</Tag>
                }
                else if (value === "refused") {
                    return <Tag color={'red'}>Bị từ chối</Tag>
                }
            }
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'createdAt',
            sorter: true,
            align: 'center',
            render: (value) => {
                return formatDateTime(value)
            }
        },
        {
            title: 'Hành động',
            dataIndex: 'operation',
            align: 'center',
            render: (value,record) => {
                if (record.state === "pending") {
                    return (
                        <Space>
                            <Button icon={<QrcodeOutlined/>} onClick={() => handleShowQrCode(record.id)} title={'Mã QR'}/>
                            <Popconfirm
                                title={'Cập nhật đơn rút tiền'}
                                description={'Bạn muốn xác nhận duyệt đơn rút tiền này?'}
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => handleUpdateState(record.id,"processed")}
                            >
                                <Button icon={<CheckOutlined/>} ghost={true} type={'primary'} title={'Duyệt'}/>
                            </Popconfirm>
                            <Popconfirm
                                title={'Cập nhật đơn rút tiền'}
                                description={'Bạn muốn từ chối đơn rút tiền này và hoàn tiền cho đối tác?'}
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => handleUpdateState(record.id,"refused")}
                            >
                                <Button icon={<FontAwesomeIcon icon={faBan}/>} danger={true} type={'primary'} title={'Từ chối'}/>
                            </Popconfirm>
                        </Space>
                    )
                }
            }
        }
    ];
    const save =  async (id, data) => {
        try {
            const newData = [...dataSource];
            const index = newData.findIndex((item) => id === item.id);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...data,
                });
                setDataSource(newData);
            } else {
                newData.push(data);
                setDataSource(newData);
            }
        } catch (e) {
            console.log('Validate Failed:', e);
        }
        finally {
        }
    }
    const handleUpdateState = (id,state) => {
        setLoading(true);
        const fetchUpdate = async () => {
            const response = await updateWithdraw( id, {
                state
            });
            if (response.success) {
                await save(id, response.data);
            }
        }
        fetchUpdate().finally(() => setLoading(false));
    }
    const handleShowQrCode = (uuid) => {
        setLoading(true);
        const fetchQrCode = async () => {
            const response = await getImageQrCode( uuid);
            if (response.success) {
                setOpenModal(true);
                setQrcode(response.data.qrcode);
            }
        }
        fetchQrCode().finally(() => setLoading(false));
    }
    const fetchDataTable = async () => {
        setTableLoading(true);
        const response = await getWithdrawals(tableParams);
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
        }
        setTableLoading(false);
    }
    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            ...tableParams,
            pagination,
            filters,
            sorter,
        });
    };
    useEffect(() => {
        setLoading(true);
        const fetchPartners = async () => {
            const response = await searchPartner(query);
            if (response.success) {
                setOptionQuery(response.data)
            }
        }
        fetchPartners().finally(setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])
    useEffect(() => {
        fetchDataTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.sorter),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.search),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.filters),
    ])
    return (
        <Page title="Rút số dư">
            {contextHolder}
            <div className="p-6">
                <Card>
                    <Form layout="vertical" className="mb-4">
                        <Row gutter={16}>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <Form.Item label="Thời gian">
                                    <RangePicker
                                        style={{ width: '100%' }}
                                        onChange={(dates) => {
                                            setTableParams({
                                                ...tableParams,
                                                search: {
                                                    ...tableParams.search,
                                                    createdAt: dates
                                                }
                                            });
                                        }}
                                        value={tableParams.search.createdAt}
                                        placeholder={['Từ ngày', 'Đến ngày']}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <Form.Item label="Đối tác">
                                    <Select
                                        showSearch
                                        placeholder="Chọn đối tác"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            setTableParams({
                                                ...tableParams,
                                                search: {
                                                    ...tableParams.search,
                                                    userId: value
                                                }
                                            });
                                        }}
                                        onSearch={value => setQuery(value)}
                                        filterOption={false}
                                        allowClear
                                        options={optionQuery.map(partner => ({
                                            value: partner.userId,
                                            label: partner.name
                                        }))}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <Table
                        rowKey={'id'}
                        columns={columns}
                        dataSource={dataSource}
                        bordered={true}
                        scroll={{
                            x: 1800,
                        }}
                        loading={tableLoading}
                        pagination={tableParams.pagination}
                        onChange={handleTableChange}
                    />
                </Card>
            </div>
            <Modal
                title={'Mã QR code chuyển tiền'}
                open={openModal}
                onOk={() => setOpenModal(false)}
                onCancel={() => setOpenModal(false)}
            >
                <Flex
                    justify={'center'}
                    align={'center'}
                >
                    <QRCode value={qrCode}/>
                </Flex>
            </Modal>
        </Page>
    )
}
export default Withdraw;